var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiftgateClosed2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4009_108869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 14 13.3972 14.1849 21.5 16.5C32 19.5 48 26 48 26C48.1493 26.0531 45.6072 27.6196 43.9282 28.6387C43.2823 29.0307 43.275 29.9828 43.8946 30.4153C45.0044 31.1899 46.5124 32.3541 47.3909 33.4999C48.9034 35.4725 48.6287 39.0129 47.8951 41.8834C46.3826 47.8012 45.8784 48.6889 42.8535 49.2807C37.8119 50.267 30.9251 51.0067 28.737 51.2533",
    stroke: "#C9C9D1",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 58C25.7467 58 30 53.7467 30 48.5C30 43.2533 25.7467 39 20.5 39C15.2533 39 11 43.2533 11 48.5C11 53.7467 15.2533 58 20.5 58Z",
    stroke: "#C9C9D1",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 50L0 50",
    stroke: "#C9C9D1",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4009_108869"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiftgateClosed2);
export default __webpack_public_path__ + "static/media/liftgate-closed-2.61934946e3e472685ee955b846a2e66c.svg";
export { ForwardRef as ReactComponent };